import React, {useState} from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid } from '@material-ui/core';

import { AccountProfile, AccountDetails } from './components';


import { GetAccountInfo } from 'utils/requests'
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import PropTypes from "prop-types";
// import UserList from "../UserList/UserList";


let isLoading = true;

function useForceUpdate(){
  const [value, setValue] = useState(0); // integer state
  return () => setValue(value => ++value); // update the state to force render
}

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const AccountInfo = async (forceUpdate, history) =>{
  if(isLoading){
    return GetAccountInfo()
      .then((res) => {
        if(res){
          if(res[0] === 0){
            isLoading = false;
            user = res[1]
            forceUpdate();
          } else if(res[0] === 2){
            history.push('/sign-in');
          } else if(res[0] === 1){
            // console.log(res);
            alert('An arror happened while fetching for data');
            history.push('/sign-in');
          }
        } else{
          alert('An arror happened while fetching for data');
        }
      })
  }
}

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4)
  }
}));

let user

const Account = (props) => {

  const { history, location } = props;

  const forceUpdate = useForceUpdate();
  AccountInfo(forceUpdate, history);
  const classes = useStyles();

  // console.log(location)
  var isFirst = location

  const [open, setOpen] = React.useState(location.state?.new_account ? true : false);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  // checkisFirst()

  return (
    <div>
      <div>
      <Snackbar open={open} autoHideDuration={12000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="warning">
          Make sure to upload your CV and picture, and complete any missing details
        </Alert>
      </Snackbar>
    </div>
    <div>
      {!isLoading && 
    <div className={classes.root}>
      <Grid
        container
        spacing={4}
      >
        <Grid
          item
          lg={5}
          md={5}
          xl={5}
          xs={12}
        >
          <AccountProfile data={user}/>
        </Grid>
        <Grid
          item
          lg={7}
          md={7}
          xl={7}
          xs={12}
        >
          <AccountDetails data={user} />
        </Grid>
      </Grid>
    </div>
      }
    </div>
    </div>
  );
};

Account.propTypes = {
  history: PropTypes.object
};

export default Account;
